import { BeBox, BeCol, BeCols, BePage, BeStack } from "@beos-css/react/index.ts";

export function MeasureDemo() {
	const prose =
		"A run of body text is capped at a readable line length, not at the width of whatever box it lands in. The cell keeps growing; the line stops.";
	return (
		<section id="demo-page-measure">
			<h2>Measure (.be-measure)</h2>
			<p>
				The third kind of sizing, and the one neither grid does: a width that does not track its container at all. <code>--be-measure</code>{" "}
				is <code>70ch</code> — a count of CHARACTERS, so it holds a readable line whatever the font size, and a pixel cap could not express
				it. Where you put it decides what caps: on a BOX the box narrows; on the TEXT only the line does, and the box stays wide.
			</p>
			<BePage className="be-panel" pad={1}>
				<BeStack gap="section">
					<BeBox className="be-measure" label="measure on the BOX — the box itself stops at 70ch">
						{prose}
					</BeBox>
					<BeCols>
						<BeCol span={8}>
							<BeBox label="no measure — fills the cell">{prose}</BeBox>
						</BeCol>
						<BeCol span={8}>
							<BeBox label="measure on the TEXT — box stays wide">
								<p className="be-measure">{prose}</p>
							</BeBox>
						</BeCol>
					</BeCols>
				</BeStack>
			</BePage>
		</section>
	);
}
